<template>
  <v-row justify="center" class="modal-row-container">
    <v-card flat class="modal-card">
      <v-card-title>
        <span class="headline">{{ modalTitle }} IVR Option</span>
        <v-spacer></v-spacer>
        <v-btn text icon color="grey" @click="onClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-container>
          <confirm-delete-in-modal
            v-if="showConfirmDelete"
            @confirmed="onConfirmDelete"
          ></confirm-delete-in-modal>
          <v-form ref="form" v-model="valid">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  label="Key Pressed"
                  hint="0-9, *, or # key"
                  persistent-hint
                  required
                  :rules="[rules.required, rules.phonekeypad]"
                  v-model="digit"
                  v-mask="masks.phonekeypad"
                  :autocomplete="false"
                  outlined
                ></v-text-field>
              </v-col>
              <!-- <v-col cols="12">
                <v-text-field
                  label="Spoken Response"
                  hint="The spoken word or phrase to match (use a comma to give multiple matches)"
                  persistent-hint
                  required
                  :rules="[rules.required, rules.words]"
                  v-model="verbal"
                  v-mask="masks.nomask"
                  :autocomplete="false"
                  outlined
                ></v-text-field>
              </v-col> -->
              <v-col cols="12">
                <v-autocomplete
                  required
                  :rules="[rules.required]"
                  v-model="selectedRedirectTo"
                  :items="otherCallFlows"
                  item-text="name"
                  item-value="id"
                  :filter="callFlowsCustomFilter"
                  label="Select a Call Flow"
                  dense
                  autocomplete="off"
                  outlined
                >
                  <template v-slot:item="{ item }">
                    <v-list-item-content>
                      <v-list-item-title
                        >{{ item.name }}&nbsp;{{
                          item.id == FlowId ? "(current flow)" : ""
                        }}</v-list-item-title
                      >
                      <v-list-item-subtitle
                        >{{ item.meta.flow.length }} steps</v-list-item-subtitle
                      >
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions class="modal-actions">
        <v-spacer></v-spacer>
        <v-btn v-if="showDelete" color="blue darken-1" text @click="onDelete"
          >Delete</v-btn
        >
        <v-btn color="primary tile" @click="onSave"
          >&nbsp;&nbsp;&nbsp;Save&nbsp;&nbsp;&nbsp;</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-row>
</template>

<script>
import { VALIDATION_RULES } from "../../../helpers/ValidationRules";
import { MASKS } from "../../../helpers/Masks";
import { mask } from "vue-the-mask";

const ConfirmDeleteInModal = () =>
  import(
    /* webpackChunkName: "components-customers-modals-ConfirmDeleteInModal" */ `../../customers/modals/ConfirmDeleteInModal.vue`
  );

export default {
  name: "CallFlowIVROptionModal",
  props: {
    FlowId: Number,
    flowList: {
      type: Array,
      required: true
    },
    config: {
      type: Object,
      required: true
    },
    ordinal: Number,
    onIVROptionUpdate: Function
  },
  directives: {
    mask
  },
  components: {
    ConfirmDeleteInModal
  },
  data: () => ({
    valid: true,
    showConfirmDelete: false,
    masks: MASKS,
    rules: VALIDATION_RULES,

    digit: null,
    verbal: null,
    selectedRedirectTo: null
  }),
  computed: {
    modalTitle() {
      return this.ordinal == null ? "Add" : "Edit";
    },
    // isAddNew() {
    //   return this.callFlowId == -1;
    // },
    showDelete() {
      return this.config.redirectTo && !this.showConfirmDelete;
    },
    callFlowType() {
      const listType = this.$store.getters["entities/listTypes/query"]()
        .withAllRecursive(1)
        .where("code", value => ["call_flow"].includes(value))
        .first();
      return listType;
    },
    callFlowTypeId() {
      const listType = this.callFlowType;
      if (listType && listType.id) {
        return listType.id;
      }
      return null;
    },
    otherCallFlows() {
      return this.callFlowType.items;
    },
    redirectTo() {
      const selected = this.selectedRedirectTo;
      return this.callFlowType.items.filter(
        value => value.id == this.selectedRedirectTo
      )[0].meta.uid;
    }
  },
  created() {
    if (this.ordinal != null) {
      const thisOption = this.config.responses[this.ordinal];
      this.digit = thisOption.digit;
      this.verbal = thisOption.verbal;
      this.selectedRedirectTo = this.callFlowType.items.filter(
        value => value.meta.uid == thisOption.redirectTo
      )[0].id;
    }
  },
  methods: {
    onClose() {
      this.$parent.$parent.$parent.ivrOptionDialog = false;
    },
    onSave() {
      if (this.$refs.form.validate()) {
        let responses = [];
        if (this.config.responses) {
          responses = [...this.config.responses];
        }
        const newResponse = {
          rank: this.ordinal,
          digit: this.digit,
          verbal: this.verbal,
          redirectTo: this.redirectTo
        };
        if (typeof this.ordinal == "number") {
          responses.splice(this.ordinal, 1, newResponse);
        } else {
          responses.push(newResponse);
        }
        for (let i = 0; i < responses.length; i++) {
          responses[i].rank = i;
        }
        this.digit = null;
        this.verbal = null;
        this.selectedRedirectTo = null;
        this.showConfirmDelete = false;
        this.onIVROptionUpdate(responses);
      }
    },
    onDelete() {
      this.showConfirmDelete = true;
    },
    onConfirmDelete() {
      this.$store.dispatch("entities/listItems/deleteListItem", {
        id: this.FlowId,
        isDirty: true
      });
      this.onClose();
    },
    callFlowsCustomFilter(item, queryText, itemText) {
      const textOne = item.name.toLowerCase();
      const searchText = queryText.toLowerCase();
      return textOne.indexOf(searchText) > -1;
    }
  },
  watch: {
    digit(newVal, oldVal) {
      if (oldVal != newVal) {
        switch (newVal) {
          case "1":
            this.verbal = "one";
            break;
          case "2":
            this.verbal = "two";
            break;
          case "3":
            this.verbal = "three";
            break;
          case "4":
            this.verbal = "four";
            break;
          case "5":
            this.verbal = "five";
            break;
          case "6":
            this.verbal = "six";
            break;
          case "7":
            this.verbal = "seven";
            break;
          case "8":
            this.verbal = "eight";
            break;
          case "9":
            this.verbal = "nine";
            break;
          case "0":
            this.verbal = "zero,oh";
            break;
          case "*":
            this.verbal = "star,asterisk";
            break;
          case "#":
            this.verbal = "pound,hashtag";
            break;
        }
      }
    },
  }
};
</script>
<style scoped lang="stylus">
.modal-row-container {
  padding: 1rem;
  margin: 0;
}
.modal-card {
  width: 100%;
  margin: 0;
}
.headline {
  padding-left: .5rem;
}
.modal-actions {
  padding: 1rem;
}
</style>
